<template>
  <div class="invite-review" v-loading="loading" v-if="!this.currentCompany.syncDing">
    <div class="title">邀请审核</div>
    <div class="right">
      <div class="mRight10">
        <review-search ref="reviewSearch" @search="search"></review-search>
      </div>
      <base-button type="primary" @click="goToInviteSetting">邀请设置</base-button>
    </div>
    <section class="main-wrap">
      <base-table
        ref="BaseTable"
        tableHeight="100%"
        :tableColumns="reviewColumns"
        :tableData="filterData"
        :pageInfo="pageInfo"
      >
        <el-table-column
          v-for="(item, index) in reviewColumns"
          :key="index"
          :prop="item.value"
          :label="item.label"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="item.value === 'status'">
              <el-tag v-if="scope.row.status === '待审核'" type="warning" effect="dark" size="mini">
                待审核
              </el-tag>
              <el-tag
                v-else-if="scope.row.status === '已通过'"
                type="success"
                effect="dark"
                size="mini"
              >
                已通过
              </el-tag>
              <el-tag
                v-else-if="scope.row.status === '已拒绝'"
                type="info"
                effect="dark"
                size="mini"
              >
                已拒绝
              </el-tag>
            </template>
            <template v-else>
              {{ _.get(scope.row, item.value) }}
            </template>
          </template>
        </el-table-column>
        <template v-slot:table-suffix>
          <el-table-column label="操作" min-width="80" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === '待审核'"
                type="text"
                @click="getUserInfo(scope.row)"
              >
                审核
              </el-button>
            </template>
          </el-table-column>
        </template>
      </base-table>
    </section>
    <base-dialog show-close :visible.sync="agreeVisible" width="450px">
      <template v-slot:header>成员加入审核</template>
      <div style="margin: 40px 40px 10px; color: #606266">是否同意该成员加入企业?</div>
      <template v-slot:footer>
        <span class="dialog-footer">
          <base-button @click="reject">驳回</base-button>
          <base-button type="primary" @click="editStaff(staffInfo)">同意</base-button>
        </span>
      </template>
    </base-dialog>
    <edit-dialog
      ref="editDialog"
      from="invite-review"
      :recordId="recordId"
      @refresh="refresh"
    ></edit-dialog>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import BaseButton from "@/components/UIComponents/Button"
import BaseDialog from "@/components/BaseComponents/Dialog"
import EditDialog from "./CompanyUser/DptMember/EditDialog"
import ReviewSearch from "./ReviewSearch"
import { reviewColumns } from "@/views/Company/Manage/User/static"
import { getCurCompany, getDepartmentTree } from "@/api/userCenter/company"
import { getRecordList, verifyJoinRecord } from "@/api/user"
import TableController from "@/views/Backend/Admin/Layout/mixin/TableController"

export default {
  name: "invite-review",
  components: { BaseTable, BaseDialog, BaseButton, EditDialog, ReviewSearch },
  provide() {
    return {
      rootDepartment: this.company,
      currentCompany: this.currentCompany
    }
  },
  data() {
    return {
      reviewColumns,
      currentCompany: { syncDing: false },
      company: {
        id: "",
        name: "",
        adminIds: "",
        children: "",
        companyId: "",
        createAt: ""
      },
      searchText: "",
      loading: false,
      filterData: [],
      pageInfo: { total: 1000, currentPage: 1, pageSize: 20 },
      users: [],
      agreeVisible: false,
      staffInfo: { name: "", telephone: "", id: "" },
      recordId: ""
    }
  },
  mixins: [TableController],
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      Promise.all([
        getCurCompany()
          .then(currentCompany => Object.assign(this.currentCompany, currentCompany))
          .then(() => {
            getRecordList(this.currentCompany.id).then(res => {
              this.users = res
              this.filterData = this.users.map(data => this.dealData(data))
              this.resetPageInfo(this.filterData)
            })
          }),
        getDepartmentTree({ noCache: true }).then(res => {
          Object.assign(this.company, res[0])
          this.convertDpt(this.company.children)
        })
      ]).finally(() => (this.loading = false))
    },
    dealData(data) {
      data.name = data.user?.name
      data.telephone = data.user?.telephone
      return data
    },
    convertDpt(dptTree) {
      dptTree.forEach(dpt => {
        if (dpt.children?.length) this.convertDpt(dpt.children)
        else delete dpt.children
      })
    },
    search(searchInfo, filterKeys) {
      this.handleSearch({
        tableData: this.users,
        filterKeys: filterKeys,
        searchText: searchInfo
      })
    },
    goToInviteSetting() {
      this.$router.push({ name: "company-invite-setting" })
    },
    editStaff(userInfo) {
      this.$refs.editDialog.open(userInfo)
      this.agreeVisible = false
    },
    getUserInfo(userInfo) {
      this.agreeVisible = true
      this.staffInfo = {
        name: userInfo.name,
        telephone: userInfo.telephone,
        id: userInfo.userId
      }
      this.recordId = userInfo.id
    },
    reject() {
      verifyJoinRecord(false, this.recordId, {}).then(() => {
        this.refresh()
        this.agreeVisible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-review {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  .title {
    font-size: $font-size-title-first;
    padding: 0 20px 10px 20px;
    border-bottom: 1px solid #e4e4e4;
  }
  .right {
    display: flex;
    float: right;
    margin: 15px 20px;
    ::v-deep {
      .el-input-group__append {
        padding: 0 10px;
      }
    }
  }
  ::v-deep {
    .right {
      margin-left: auto;
    }
  }
  .main-wrap {
    flex: 1 1;
    overflow: hidden;
    .base-table {
      height: 100%;
    }
  }
}
</style>
